module.exports = {"pagination":{}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/aws-sdk/apis/marketplacecommerceanalytics-2015-07-01.paginators.json
// module id = 446
// module chunks = 0